<template>
  <div @click="stopPropagation" class="date-picker">
    <span>{{title}}:</span>
    <div class="filter style-class">
        <span class="filter-label">{{shortFormatDate(datePickerValue)}}</span>
        <div class="dropdown-btn" @click="showCalendar()" >
          <image-svg :imageName="'arrow-expand'"/>
        </div>
    </div>
    <date-picker
        ref="datePicker"
        v-model="datePickerValue"
        :disabledDates="disabledDates"/>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import ImageSVG from '@/components/common/ImageSVG.vue'
export default {
  components: {
    'date-picker': Datepicker,
    'image-svg': ImageSVG
  },
  props: {
    title: String,
    disabledDates: {
      type: Object,
      default: function () {
        return {
          to: new Date(2019, 0, 1),
          from: new Date()
        }
      }
    }
  },
  data () {
    return {
      datePickerValue: new Date(),
      calendar: 'datePicker',
      isItemClicked: false
    }
  },
  watch: {
    datePickerValue: function (val, old) {
      this.$emit('input', val)
    }
  },
  methods: {
    stopPropagation () {
      if (!this.$refs[this.calendar].isOpen) {
        event.stopPropagation()
        return
      }
      setTimeout(() => {
        this.showCalendar()
      })
    },
    hideCalendar () {
      if (this.$refs[this.calendar].isOpen) {
        return this.$refs[this.calendar].close()
      }
    },
    showCalendar () {
      if (this.$refs[this.calendar].isOpen) {
        return this.$refs[this.calendar].close()
      }
      if (!this.$refs[this.calendar].allowedToShowView('day')) {
        return false
      }
      this.$refs[this.calendar].close()
      this.$refs[this.calendar].showDayView = true
      if (!this.$refs[this.calendar].isInline) {
        setTimeout(() => {
          document.addEventListener('click', this.$refs[this.calendar].clickOutside, false)
        }, 100)
      }
    },
    shortFormatDate (value) {
      return value.getDate() + '-' + (value.getMonth() + 1) + '-' + value.getFullYear()
    }
  }
}
</script>
